

function omitNumber1(e) {
  let value = e;
  if(value.indexOf(".")<0){
    value = value.slice(0,9)
  }
  if(value.indexOf(".")>=9){
    value = value.slice(0,9) + value.slice(value.indexOf("."))
  }
  
  value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
  value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
  value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
  value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
  if (value.indexOf(".") < 0 && value != "") {
    //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    value = parseFloat(value);
  }
  if(value=='.'){
    value = '0.'
  }
  return value;
}
export let omitNumber = omitNumber1;
let monthOption1 = [
  {
    title: '基础信息',
    component: 'el-divider',
    span: 24,
    tips: '看我：自定义属性怎么用？',
    labelWidth: '0px',
    params: {
      html: '<h3 style=\"color:#333;font-weight:blod;\">基础信息</h3>',
      contentPosition: 'left'
    },
    prop: 'ww1'
  },
  {
    type: 'select',
    label: '项目名称',
    dicData: [],
    cascaderItem: [],
    span: 8,
    disabled:true,
    display: true,
    props: {
      label: 'name',
      value: 'id'
    },
    prop: 'projectId',
    required: true,
    rules: [
      {
        required: true,
        message: '请选择'
      }
    ]
  },
  {
    type: 'select',
    label: '部门名称',
    dicData: [],
    cascaderItem: [],
    span: 8,
    display: true,
  
    props: {
      label: 'name',
      value: 'id'
    },
    formslot:true,
    prop: 'deptId',
    required: true,
    rules: [
      {
        required: true,
        message: '请选择部门'
      }
    ]
  },
 

  {
    type: 'select',
    label: '仪表类型',
    dicUrl: 'api/blade-system/dict/dictionary?code=meter_type',
    props: { label: 'dictValue', value: 'dictKey' },
    span: 8,
    dataType:'number',
    display: true,
    // formslot:true,
    prop: 'meterType',
    required: true,
    rules: [
      {
        required: true,
        message: '请选择仪表类型'
      }
    ]
  },
  {
    title: '能耗指标',
    component: 'el-divider',
    span: 24,
    tips: '看我：自定义属性怎么用？',
    labelWidth: '0px',
    params: {
      html: '<h3 style=\"color:#333;font-weight:blod;\">能耗指标</h3>',
      contentPosition: 'left'
    },
    prop: 'abc1'
  },
  {
    type: 'select',
    label: '能耗周期',
    dicUrl: 'api/blade-system/dict/dictionary?code=energy_cost_cycle_unit',
    clearable:false,
    span: 8,
    display: true,
    filterable:true,
    row:true,
    value:'2',
    props: { label: 'dictValue', value: 'dictKey' },
    prop: 'costCycleUnit',
    required: true,
    rules: [
      {
        required: true,
        message: '请选择能耗周期'
      }
    ]
  },
  {
    type: 'input',
    label: '能耗指标 1月',
    labelWidth:"130",
    disabled:false,
    span:8,
    prop: 'energy1',
    formslot:true,
    
  },
  {
    type: 'input',
    label: '能耗指标 2月',
    labelWidth:"130",
    disabled:false,
    formslot:true,
    span:8,
    prop: 'energy2',
   
  },
  {
    type: 'input',
    label: '能耗指标 3月',
    labelWidth:"130",
    disabled:false,
    formslot:true,
    span:8,
    prop: 'energy3',
   
  },
  {
    type: 'input',
    label: '能耗指标 4月',
    labelWidth:"130",
    disabled:false,
    formslot:true,
    span:8,
    prop: 'energy4',
    
  },
  {
    type: 'input',
    label: '能耗指标 5月',
    labelWidth:"130",
    formslot:true,
    disabled:false,
    span:8,
    prop: 'energy5',
 
  },
  {
    type: 'input',
    label: '能耗指标 6月',
    labelWidth:"130",
    formslot:true,
    disabled:false,
    span:8,
    prop: 'energy6',

  },
  {
    type: 'input',
    label: '能耗指标 7月',
    labelWidth:"130",
    formslot:true,
    disabled:false,
    span:8,
    prop: 'energy7',
 
  },
  {
    type: 'input',
    label: '能耗指标 8月',
    labelWidth:"130",
    formslot:true,
    disabled:false,
    span:8,
    prop: 'energy8',

  },
  {
    type: 'input',
    label: '能耗指标 9月',
    labelWidth:"130",
    formslot:true,
    disabled:false,
    span:8,
    prop: 'energy9',

  },
  {
    type: 'input',
    label: '能耗指标 10月',
    labelWidth:"130",
    formslot:true,
    disabled:false,
    span:8,
    prop: 'energy10',

  },
  {
    type: 'input',
    label: '能耗指标 11月',
    disabled:false,
    formslot:true,
    span:8,
    labelWidth:"130",
    prop: 'energy11',
 
  },
  {
    type: 'input',
    label: '能耗指标 12月',
    disabled:false,
    formslot:true,
    span:8,
    labelWidth:"130",
    prop: 'energy12',
   
  },
  
 
  {
    title: '计量设置',
    component: 'el-divider',
    span: 24,
    tips: '看我：自定义属性怎么用？',
    labelWidth: '0px',
    params: {
      html: '<h3 style=\"color:#333;font-weight:blod;\">计量设置</h3>',
      contentPosition: 'left'
    },
    prop: 'abc4'
  },
  {
    type: 'textarea',
    label: '',
    labelWidth:0,
    span: 24,
    formslot:true,
    display: true,
    prop: 'settings'

  },

];







let yearOption1 = [
  {
    title: '基础信息',
    component: 'el-divider',
    span: 24,
    tips: '看我：自定义属性怎么用？',
    labelWidth: '0px',
    params: {
      html: '<h3 style=\"color:#333;font-weight:blod;\">基础信息</h3>',
      contentPosition: 'left'
    },
    prop: 'ww1'
  },
  {
    type: 'select',
    label: '项目名称',
    dicData: [],
    cascaderItem: [],
    span: 8,
    disabled:true,
    display: true,
    props: {
      label: 'name',
      value: 'id'
    },
    prop: 'projectId',
    required: true,
    rules: [
      {
        required: true,
        message: '请选择下拉选择器'
      }
    ]
  },
  {
    type: 'select',
    label: '部门名称',
    dicData: [],
    cascaderItem: [],
    span: 8,
    display: true,
  
    props: {
      label: 'name',
      value: 'id'
    },
    formslot:true,
    prop: 'deptId',
    required: true,
    rules: [
      {
        required: true,
        message: '请选择部门'
      }
    ]
  },

  {
    type: 'select',
    label: '仪表类型',
    span: 8,
    dataType:'number',
    valueType:'number',
    display: true,
    dicUrl: 'api/blade-system/dict/dictionary?code=meter_type',
    props: { label: 'dictValue', value: 'dictKey' },
    prop: 'meterType',
    required: true,
    rules: [
      {
        required: true,
        message: '请选择仪表类型'
      }
    ]
  },
  {
    title: '能耗指标',
    component: 'el-divider',
    span: 24,
    tips: '看我：自定义属性怎么用？',
    labelWidth: '0px',
    params: {
      html: '<h3 style=\"color:#333;font-weight:blod;\">能耗指标</h3>',
      contentPosition: 'left'
    },
    prop: 'abc1'
  },
  {
    type: 'select',
    label: '能耗周期',
    dicUrl: 'api/blade-system/dict/dictionary?code=energy_cost_cycle_unit',
    span: 8,
    clearable:false,
    display: true,
    filterable:true,
    row:true,
    value:'2',
    props: { label: 'dictValue', value: 'dictKey' },
    prop: 'costCycleUnit',
    required: true,
    rules: [
      {
        required: true,
        message: '请选择能耗周期'
      }
    ]
  },
  {
    type: 'input',
    label: '能耗指标 年',
    labelWidth:"130",
    disabled:false,
    span:8,
    prop: 'energyYear',
    formslot:true,
  
  },
  {
    type: 'input',
    label: '能耗指标 2月',
    labelWidth:"130",
    disabled:false,
    display:false,
    span:8,
    prop: 'energy2',
    required: true,
    rules: [
      {
        message: '请输入能耗指标'
      }
    ]
  },
  {
    type: 'input',
    label: '能耗指标 3月',
    labelWidth:"130",
    display:false,
    disabled:false,
    span:8,
    prop: 'energy3',
    rules: [
      {
        message: '请输入能耗指标'
      }
    ]
  },
  {
    type: 'input',
    label: '能耗指标 4月',
    labelWidth:"130",
    display:false,
    disabled:false,
    span:8,
    prop: 'energy4',
    required: true,
    rules: [
      {
        message: '请输入能耗指标'
      }
    ]
  },
  {
    type: 'input',
    label: '能耗指标 5月',
    labelWidth:"130",
    display:false,
    disabled:false,
    span:8,
    prop: 'energy5',
    required: true,
    rules: [
      {
        message: '请输入能耗指标'
      }
    ]
  },
  {
    type: 'input',
    label: '能耗指标 6月',
    labelWidth:"130",
    disabled:false,
    display:false,
    span:8,
    prop: 'energy6',
    required: true,
    rules: [
      {
        message: '请输入能耗指标'
      }
    ]
  },
  {
    type: 'input',
    label: '能耗指标 7月',
    labelWidth:"130",
    disabled:false,
    display:false,
    span:8,
    prop: 'energy7',
    required: true,
    rules: [
      {
        message: '请输入能耗指标'
      }
    ]
  },
  {
    type: 'input',
    label: '能耗指标 8月',
    labelWidth:"130",
    display:false,
    disabled:false,
    span:8,
    prop: 'energy8',
    required: true,
    rules: [
      {
        message: '请输入能耗指标'
      }
    ]
  },
  {
    type: 'input',
    label: '能耗指标 9月',
    labelWidth:"130",
    display:false,
    disabled:false,
    span:8,
    prop: 'energy9',
    required: true,
    rules: [
      {
        message: '请输入能耗指标'
      }
    ]
  },
  {
    type: 'input',
    label: '能耗指标 10月',
    labelWidth:"130",
    disabled:false,
    display:false,
    span:8,
    prop: 'energy10',
    required: true,
    rules: [
      {
        message: '请输入能耗指标'
      }
    ]
  },
  {
    type: 'input',
    label: '',
    disabled:false,
    span:8,
    display:false,

    labelWidth:"130",
    prop: 'energy11',
    required: true,
    rules: [
      {
        message: '请输入能耗指标'
      }
    ]
  },
  {
    type: 'input',
    label: '能耗指标 12月',
    disabled:false,
    span:8,
    display:false,
    labelWidth:"130",
    prop: 'energy12',
    rules: [
      {
        message: '请输入能耗指标'
      }
    ]
  },
  
 
  {
    title: '计量设置',
    component: 'el-divider',
    span: 24,
    tips: '看我：自定义属性怎么用？',
    labelWidth: '0px',
    params: {
      html: '<h3 style=\"color:#333;font-weight:blod;\">计量设置</h3>',
      contentPosition: 'left'
    },
    prop: 'abc4'
  },
  {
    type: 'textarea',
    label: '',
    labelWidth:0,
    span: 24,
    formslot:true,
    display: true,
    prop: 'settings'

  },

];


export let monthOption = monthOption1;
export let yearOption = yearOption1;

export let defaultOption={
        column:[],
              labelPosition: 'right',
              labelSuffix: '：',
              labelWidth: 100,
              gutter: 0,
              submitBtn: true,
              submitIcon:'none',
              submitText: '提交',
              emptyBtn:false,
              menuBtn: true,
              menuPosition: 'center',
              disabled:false,
              
}


// exports.option.default=